import { render, staticRenderFns } from "./DescriptionsCard.vue?vue&type=template&id=a1c785c6&"
import script from "./DescriptionsCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionsCard.vue?vue&type=style&index=0&id=a1c785c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports